<template>
    <client-page>
        <div id="contents">
            <v-container>
                <div class="title-wrap title-wrap--line">
                    <h2 class="font-42">커스텀 게시판</h2>
                </div>

                <customer-list></customer-list>

            </v-container>
        </div>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import CustomerList from "@/components/client/en/board/customer/list.vue"
export default {
    components: {
        ClientPage,
        CustomerList
    },
};
</script>